import { useEffect, useRef, useState } from 'react';
import styles from '@components/DevToolbar/DevToolbar.styles';
import { IDevToolbarProps, TDevToolbarPosition, TDevToolbarTab } from '@components/DevToolbar/typescript';
import DevToolbarComponent from '@components/DevToolbar/DevToolbarComponent/DevToolbarComponent';
import DevToolbarTabGeneral from '@components/DevToolbar/DevToolbarTab/DevToolbarTabGeneral/DevToolbarTabGeneral';
import DevToolbarTabSettings from '@components/DevToolbar/DevToolbarTab/DevToolbarTabSettings/DevToolbarTabSettings';
import DevToolbarTabMore from '@components/DevToolbar/DevToolbarTab/DevToolbarTabMore/DevToolbarTabMore';
import DevToolbarTabCache from '@components/DevToolbar/DevToolbarTab/DevToolbarTabCache/DevToolbarTabCache';
import Heading from '@components/Heading/Heading';
type PropsType = {
  pageProps: Record<string, unknown>;
};
const DevToolbar = ({
  pageProps
}: PropsType) => {
  const prodPageProps = {
    ...pageProps
  };
  delete prodPageProps.devProps;
  const modalRef = useRef<HTMLDivElement>(null);
  const toolbarRef = useRef<HTMLDivElement>(null);
  const [hoverSize, setHoverSize] = useState(200);
  const [debugMode, setDebugMode] = useState(true);
  const [isHovered, setIsHovered] = useState(true);
  const [selectedTab, setSelectedTab] = useState<TDevToolbarTab | null>(null);
  const [position, setPosition] = useState<TDevToolbarPosition>('bottom');
  const disableHover = false;
  const handleClose = () => {
    if (disableHover) return;
    setIsHovered(false);
    setSelectedTab(null);
  };
  const handleOpenTab = (tab: TDevToolbarTab) => {
    setSelectedTab(tab);
  };
  useEffect(() => {
    const checkIfClickedOutside = (e: MouseEvent) => {
      const element = e.target as HTMLElement;
      if (!modalRef.current?.contains(element) && !toolbarRef.current?.contains(element)) {
        handleClose();
      }
    };
    if (isHovered) window.addEventListener('click', checkIfClickedOutside);
    return () => window.removeEventListener('click', checkIfClickedOutside);
  }, [isHovered]);
  return <>
      {/* biome-ignore lint/a11y/noStaticElementInteractions: hover element */}
      {/* biome-ignore lint/a11y/noNoninteractiveElementInteractions: hover element */}
      <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => {
      if (disableHover) return;
      handleClose();
    }}>
        <div sx={styles.hoverElement(position, hoverSize, debugMode)}>
          <div sx={styles.hoverMe(debugMode, hoverSize, position)}>
            <Heading h={4} headingType={5} bold align="center" color="black">
              Hover me
            </Heading>
          </div>
        </div>
        <div sx={styles.toolbarWrapper(isHovered, position, false)}>
          <div sx={styles.toolbar(position, false)}>
            <div sx={styles.componentsWrapper} ref={toolbarRef}>
              <DevToolbarComponent icon="Error" color="white" onClick={() => handleOpenTab('Cache')} isActive={selectedTab === 'Cache'} />
              <DevToolbarComponent icon="WatchOutlined" color="white" onClick={() => handleOpenTab('Performance')} isActive={selectedTab === 'Performance'} />
              <DevToolbarComponent icon="Settings" color="white" onClick={() => handleOpenTab('Settings')} isActive={selectedTab === 'Settings'} />
              <DevToolbarComponent icon="MoreVert" color="white" onClick={() => handleOpenTab('More')} isActive={selectedTab === 'More'} />
              <DevToolbarComponent icon="Close" color="white" onClick={handleClose} isSpecial isActive={false} />
            </div>
            <div ref={modalRef}>
              {selectedTab === 'Cache' && <DevToolbarTabCache devProps={pageProps?.devProps ? pageProps.devProps as IDevToolbarProps : null} />}
              {selectedTab === 'Performance' && <DevToolbarTabGeneral pageProps={prodPageProps} />}
              {selectedTab === 'Settings' && <DevToolbarTabSettings debugMode={debugMode} setDebugMode={setDebugMode} position={position} setPosition={setPosition} hoverSize={hoverSize} setHoverSize={setHoverSize} />}
              {selectedTab === 'More' && <DevToolbarTabMore />}
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default DevToolbar;